
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12 items-center">
          <div className="lg:col-span-3 space-y-6 md:space-y-8">
            <div className="inline-block border-2 border-primary px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <span className="text-xs md:text-sm font-semibold text-primary">TPE / PME</span>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-primary-dark leading-tight">
              Optimisez vos performances et soulagez vos équipes
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-gray-dark italic leading-relaxed">
              Dans un environnement concurrentiel exigeant, vos équipes méritent les meilleurs outils et accompagnements pour exceller. Nous vous aidons à gagner en efficacité tout en maîtrisant vos coûts.
            </p>
            <ul className="space-y-3 md:space-y-4">
              {[
                'Solutions d\'externalisation à moindre coût',
                'Audit commercial qualitatif et actionnable',
                'Formations sur-mesure pour vos équipes',
                'Stratégie d\'e-réputation et visibilité',
                'Optimisation des charges patronales',
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5 md:mt-1">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-sm md:text-base text-gray-dark font-medium">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/formulaire"
              className="inline-flex items-center gap-3 bg-primary text-white px-8 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-primary-dark transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Rejoindre le réseau
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="lg:col-span-2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ab08848ec30a3b4abea212dbb5b8ba20.jpg"
                alt="Équipe TPE/PME"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
